import React, { ReactNode } from 'react';
import theme from './MeasurementDetailsField.module.scss';
import { Trans } from '@lingui/react/macro';

export interface MeasurementDetailsFieldProps {
    show: boolean;
    caption: ReactNode;
    children: ReactNode;
}

export const MeasurementDetailsField: React.FC<MeasurementDetailsFieldProps> = ({ show, caption, children }) => {
    return (
        <span>
            <span>{caption}:</span>
            {show ? (
                children
            ) : (
                <span className="text-missing">
                    <Trans>N/A</Trans>
                </span>
            )}
        </span>
    );
};
